import React from 'react';
import { Link } from 'react-router-dom';



import { getEnv } from '../../../../lib/utils/getEnv';


const { VITE_CDN_BASE_URL, VITE_PARTNERS_BASE_URL } = getEnv();

export const TOP_FEATURES_TITLES_CONFIG = [
  {
    title: 'Take online bookings',
    description: () => (
      <p>
        Let pet owners book therapy sessions online through the{' '}
        <Link to="/business/features#marketing">Pata Marketplace </Link>, giving clients 24/7 access to your schedule.
        With our appointment platform built for pet massage clinics, bookings are easy and stress-free.
      </p>
    ),
    image: `${VITE_CDN_BASE_URL}/images/image-lady-using-pata-on-laptop.webp`,
  },
  {
    title: 'Case management without the paperwork',
    description: () => (
      <p>
        Easily track progress with client history for pet massage sessions. Add therapy notes for pets and upload
        documents to view medical information in one central, secure place. 
      </p>
    ),
    image: `${VITE_CDN_BASE_URL}/images/image-dog-having-treat.webp`,

    action: {
      actionText: 'Book a demo',
      onClick: () => {
        window.location = `https://meetings.hubspot.com/pata/demo`;
      },
      buttonType: 'secondary',
    },
  },
  {
    title: 'Simplify admin for your massage therapy business',
    description: () => (
      <p>
        Manage massage plans for recurring clients, organise your schedule, and send automated appointment reminders
        with features designed to reduce your to-do list.
      </p>
    ),
    image: `${VITE_CDN_BASE_URL}/images/image-dog-with-letters.webp`,
  },
  {
    title: 'Easy-to-use booking platform',
    description: () => (
      <p>
        Quickly find and manage your sessions with our intuitive pet massage booking software, designed with simplicity
        in mind and backed up by Pata’s customer care team who are always happy to help.
      </p>
    ),
    image: `${VITE_CDN_BASE_URL}/images/image-lady-holding-dog-with-laptop.webp`,
    action: {
      actionText: 'Join Pata',
      onClick: () => {
        window.location = `${VITE_PARTNERS_BASE_URL}/sign-up`;
      },
      buttonType: 'primary',
    },
  },
  {
    title: 'Find pet owners in your local area',
    description: () => (
      <p>
        Join <Link to="/business/features#marketing">Pata Marketplace </Link> to boost your online presence, helping to
        promote your rehabilitation services and grow a network of clients looking for animal massage sessions. 
      </p>
    ),
    image: `${VITE_CDN_BASE_URL}/images/image-dog-in-bath.webp`,
  },
];